'use strict';

import React, { useState } from 'react';
import ReactDOM from 'react-dom'
import { Transition, TransitionGroup, CSSTransition } from 'react-transition-group';

class ConfirmationBoxInner extends React.Component {

  state = {
    show_saving_message: false,
    mounted: false,
  }

  componentDidMount = () => {
    this.setState({ mounted: true });
  }

  closeConfirmationPopup = () => {
    this.setState({ mounted: false });
    setTimeout(() => {
      this.props.popup_container.remove();
    }, 500);
  }

  handleCancelButtonClick = () => {
    this.closeConfirmationPopup();
  }

  handleConfirmButtonClick = () => {
    this.props.confirm_callback(this.closeConfirmationPopup, this.props.confirm_callback_data);
    if (this.props.show_saving_message) {
      this.setState({show_saving_message: true});
    }
    else {
      this.closeConfirmationPopup();
    }
  }

  render() {

    if (this.state.show_saving_message) {
      var inner = (
        <div className="confirmation-box__inner">
          <div className="confirmation-box__message">{this.props.show_saving_message}</div>
        </div>
      );
    }
    else {
      var yes_button_text = (this.props.yes_button_text) ? this.props.yes_button_text : 'Yes, delete it';
      var no_button_text = (this.props.no_button_text) ? this.props.no_button_text : 'No';
      var inner = (
        <div className="confirmation-box__inner">
          <div className="confirmation-box__message">{this.props.message}</div>
          <div className="confirmation-box__buttons">
            <div className="confirmation-box__button confirmation-box__yes-button" onClick={this.handleConfirmButtonClick} data-testid="confirmation-box-yes-button">{yes_button_text}</div>
            <div className="confirmation-box__button confirmation-box__no-button" onClick={this.handleCancelButtonClick}>{no_button_text}</div>
          </div>
        </div>
      );
    }

    return (
      <CSSTransition in={this.state.mounted} timeout={5000} classNames="confirmation-box-">
        <div id="confirmation-box" className="confirmation-box">
          {inner}
        </div>
      </CSSTransition>
    );

  }
}

export default function activateConfirmationBox({
    message,
    confirm_callback,
    yes_button_text = "Yes",
    no_button_text = "No",
    show_saving_message = null, // Set to a string to display a message.
    confirm_callback_data = null,
  }) {

  // Create an empty div to hold the confirmation box popup.
  var popup_container = document.createElement("div");
  document.body.appendChild(popup_container);

  // Render the popup within the hidden div.
  ReactDOM.render(
    <ConfirmationBoxInner
      popup_container={popup_container}
      message={message}
      confirm_callback={confirm_callback}
      confirm_callback_data={confirm_callback_data}
      yes_button_text={yes_button_text}
      no_button_text={no_button_text}
      show_saving_message={show_saving_message}
    />, popup_container
  );

}
